/* External */
import { memo } from 'react';

/* Components */
import FullScreenMessage from '../../components/FullScreenMessage';

/* Utils */
import useQuery from '../../hooks/useQuery';

function MessagePage() {
  const { messageKey } = useQuery();

  return <FullScreenMessage messageKey={messageKey} />;
}

export default memo(MessagePage);
